import { getDatePlusNMonths, getDatePlusNHours, Locales, TicketingFormCategory } from "@simplyk/common";

import { Translate } from "../../../../../common/hooks/useTranslate";
import { getRatesDefaultInformations } from "../../Steps/StepTickets/stepTickets.helper";

import { MINIMUM_BID_INCREMENT } from "@/common/helpers/form-edition";
import { OccurrenceWithRatesOutput, RateOutput } from "@/common/types/trpc";

export const getPlaceholderOccurrenceWithRates = ({
  formCategory,
  t,
  locale,
}: {
  formCategory: TicketingFormCategory;
  t: Translate;
  locale: Locales;
}): OccurrenceWithRatesOutput => {
  return {
    occurrence: {
      id: "6d16b7bf-d036-4451-9b0a-a8c3b2815bb3",
      startUtc: getDatePlusNMonths(new Date(), 1).toISOString(),
      endUtc: getDatePlusNHours(getDatePlusNMonths(new Date(), 1), 4).toISOString(),
      isArchived: false,
      ticketingId: "064a49a3-c575-4453-90eb-33c479d9bf9d",
      closed: false,
      closeDate: null,
    },
    rates: getPlaceholderRates({ formCategory, t, locale }).map((rate) => ({
      rateId: rate.id,
      remainingTickets: rate.remainingTickets,
      soldTicketsCount: 0,
    })),
  };
};

export const getPlaceholderRates = ({
  formCategory,
  t,
  locale,
}: {
  formCategory: TicketingFormCategory;
  t: Translate;
  locale: Locales;
}): RateOutput[] => {
  const defaultInformations = getRatesDefaultInformations({
    formCategory,
    t,
  });

  const rates: RateOutput[] = [
    {
      id: "6b24ab2f-23a4-4128-ae73-6e705c6f304e",
      amount: undefined as unknown as number, // The server model does not accept undefined but in the frontend it is allowed until we go to step tickets
      eligibleAmount: null,
      seats: null,
      minimumToBuy: null,
      maximumToBuy: Infinity,
      attendeesByTicket: null,
      membershipValidityPeriod: null,
      membershipValidityPeriodAtDate: null,
      allowAutomaticRenewal: false,
      remainingTickets: null,
      earlyBirdCloseDate: null,
      salesStartDate: null,
      salesStartAfterRateId: null,
      bidIncrement: MINIMUM_BID_INCREMENT,
      rateFields: [
        {
          id: "f7d9ddbd-475a-4033-a473-835fea822b28",
          locale,
          title: defaultInformations.rate1Title,
          description: defaultInformations.rate1Description ?? null,
        },
      ],
      sortIndex: 1,
      photoUrls: [],
      isMemberOnly: false,
      memberOnlyMembershipRateIds: [],
      isHidden: false,
      isAddOn: false,
    },
  ];

  if (defaultInformations.rate2Title) {
    rates.push({
      id: "7c84bfdd-b9b3-42fd-a888-d6e85d6a111e",
      amount: undefined as unknown as number, // The server model does not accept undefined but in the frontend it is allowed until we go to step tickets
      eligibleAmount: null,
      seats: null,
      minimumToBuy: 1,
      maximumToBuy: 5,
      attendeesByTicket: null,
      membershipValidityPeriod: null,
      membershipValidityPeriodAtDate: null,
      allowAutomaticRenewal: false,
      remainingTickets: 10,
      earlyBirdCloseDate: null,
      salesStartDate: null,
      salesStartAfterRateId: null,
      bidIncrement: MINIMUM_BID_INCREMENT,
      rateFields: [
        {
          id: "g4d9dde8-333b-4783-a471-93c8a2dba122",
          locale,
          title: defaultInformations.rate2Title,
          description: defaultInformations.rate2Description ?? null,
        },
      ],
      sortIndex: 2,
      photoUrls: [],
      isMemberOnly: false,
      memberOnlyMembershipRateIds: [],
      isHidden: false,
      isAddOn: false,
    });
  }

  return rates;
};
